@if (placeholder) {
  @if (arrowBorder()) {
    <div class="icon-block"></div>
  }
  <ng-content></ng-content>
}

@if (!placeholder) {
  @if (arrowBorder()) {
    <div class="icon-block"></div>
  }
  {{ value }}
}
